/** Italian UI copy: translate from `en.ts`; use `es.ts` to disambiguate tone and timing (checkout, delivery booked vs ready, modal cancel vs delete). */
export const TranslationsIT = {
    // languages
    languages: {
        en: 'English',
        ar: 'عربى',
        bg: 'Bulgaria',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: 'Bahasa Indonesia',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        th: 'ภาษาไทย',
        vi: 'Tiếng Việt',
        zh: '中文',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'FIN',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'NOB',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        th: 'THA',
        vi: 'VIE',
        zh: '中文',
    },
    // BASE
    phrases: {
        order_online: 'Ordina online',
        cart: 'Carrello',
        open_24: '24 ore',
        closed: 'Chiuso',
        free: 'GRATIS',
        something_went_wrong: 'Qualcosa non ha funzionato',
        try_again: 'Riprova',
    },
    constants: {
        calendar: {
            days: {
                monday: 'Lunedì',
                tuesday: 'Martedì',
                wednesday: 'Mercoledì',
                thursday: 'Giovedì',
                friday: 'Venerdì',
                saturday: 'Sabato',
                sunday: 'Domenica',
            },
        },
        services: {
            pickup: 'Asporto',
            delivery: 'Consegna a domicilio',
            dine_in: 'Al tavolo',
            table_booking: 'Prenotazione tavolo',
        },
        payment: {
            method: {
                cash: 'Contanti',
                card: 'Carta',
                stripe: 'Carta di credito',
                paypal: 'PayPal',
                cardconnect: 'Carta di credito',
                checkout: 'Checkout',
                checkout_apple_pay: 'Apple Pay (Checkout.com)',
                checkout_google_pay: 'Google Pay (Checkout.com)',
                razor_pay: 'Razor Pay',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                pesapal: 'Pesapal',
                ath_movil: 'ATH Móvil',
                custom: 'Personalizzato',
                red_dot: 'Red Dot Payment',
                gkash: 'Gkash',
                sgepay: 'SGEPAY',
                payway: 'ABA Pay',
                bancontact: 'Bancontact',
                swish: 'Swish',
                fiserv: 'Fiserv',
                viva_wallet: 'Viva Wallet',
                cabbagepay: 'CabbagePay',
                paymongo: 'PayMongo',
                authorized: 'Authorize.net',
            },
            // BACKENDMETHODNAMES
            backend_method: {
                cash: 'Contanti',
                card: 'Carta',
                stripe: 'Stripe',
                paypal: 'PayPal',
                cardconnect: 'CardConnect',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                bambora_na: 'Worldline',
                pesapal: 'Pesapal',
                ath_movil: 'ATH Móvil',
                checkout: 'Checkout',
                checkout_apple_pay: 'Apple Pay (Checkout.com)',
                checkout_google_pay: 'Google Pay (Checkout.com)',
                stripe_digital_wallet: 'Google/Apple Pay',
                razor_pay: 'Razor Pay',
                gravity: 'Gravity',
                authorized: 'Authorize.net',
                elavon: 'Elavon',
                red_dot: 'Red Dot Payment',
                gkash: 'Gkash',
                custom: 'Personalizzato',
                sgepay: 'SGEPAY',
                payway: 'ABA Pay',
                bancontact: 'Bancontact',
                swish: 'Swish',
                fiserv: 'Fiserv',
                viva_wallet: 'Viva Wallet',
                cabbagepay: 'CabbagePay',
                paymongo: 'PayMongo',
                nuvei: 'Nuvei',
                ONLINE: 'Online',
                online: 'Online',
            },
            status: {
                success: 'Completato',
                pending: 'In sospeso',
                error: 'Errore',
                refunded: 'Rimborsato',
                refunding: 'Rimborso in corso',
                partial_refunded: 'Parzialmente rimborsato',
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: 'Rimuovi',
                drop_here: 'Trascina i file qui oppure clicca per selezionarli',
                accepts: 'Accetta file {{fileTypes}}',
                errors: {
                    max_files: 'Massimo {{number}} consentiti',
                    max_size: 'Dimensione massima file {{kilobytes}} KB',
                },
            },
        },
    },
    // UI
    store: {
        global: {
            errors: {
                dine_in_close: "Il locale è chiuso: non puoi ordinare al tavolo con consegna immediata. Puoi provare per un'altra data o orario.",
            },
            buttons: {
                order: {
                    book_order: 'Prenota tavolo / ordina online',
                    order_online: 'Ordina online',
                    book_table: 'Prenota un tavolo',
                    order: 'Ordina',
                    book: 'Prenota',
                    cart: 'Carrello',
                    restart: 'Ricomincia',
                    closed: 'Locale chiuso',
                    not_accepting: 'Non accettiamo ordini',
                },
            },
        },
        modals: {
            auth: {
                login: 'Accedi',
                register: 'Registrati',
                register_commence: 'Continua',
                register_complete: 'Crea account',
                register_confirmation_sent: 'Abbiamo inviato un codice di conferma alla tua e-mail. Inseriscilo qui sotto per continuare',
                register_confirmation_resent: 'Il codice è stato inviato di nuovo; controlla anche lo spam o ricomincia da capo',
                register_restart: 'Ricomincia',
                register_resend_code: 'Invia di nuovo il codice',
                register_confirmation_code_subject: 'Codice di conferma e-mail',
                register_confirmation_code_email: 'Il tuo codice di conferma e-mail è {{confirmation_code}} (scade tra 24 ore)',
                login_placeholder: 'E-mail',
                password_placeholder: 'Password',
                confirm_password_placeholder: 'Conferma password',
                confirmation_code_placeholder: 'Codice di conferma e-mail',
                accept_terms: 'Accetto termini e condizioni',
                accept_terms_view: 'Leggi',
                login_facebook: 'Accedi con Facebook',
                login_google: 'Accedi con Google',
                benefits: 'Accedi o crea un account per salvare i tuoi ordini',
                logged_in: 'Accesso effettuato',
                logged_out: 'Disconnesso',
                password_reset: {
                    init_button: 'Invia e-mail di reimpostazione password',
                    init_success: 'Ti abbiamo inviato un link per reimpostare la password',
                    complete_button: 'Reimposta password',
                    complete_success: 'Password reimpostata: ora puoi accedere con la nuova password',
                    forgot_password_text: 'Hai dimenticato la password? ',
                    forgot_password_link: 'Reimposta password',
                    remember_password_text: 'Ricordi la password? ',
                    remember_password_link: 'Torna indietro',
                    invalid_title: 'Reimpostazione password non valida',
                    invalid_description: 'Questo link non è valido, richiedine uno nuovo',
                    invalid_link: 'Vai al login',
                    title: 'Reimpostazione password',
                    description: 'Inserisci una nuova password per il tuo account',
                },
                error_generic: 'Qualcosa non ha funzionato, riprova o contattaci',
                error_accept_terms: 'Accetta i termini e le condizioni',
                error_password_length: 'La password deve avere almeno 6 caratteri',
                error_social: 'Qualcosa non ha funzionato, riprova o contattaci',
                error_confirmation_code: 'Codice di conferma non valido',
                error_invalid_code: 'Codice di conferma non valido',
                error_exists: 'Utente già esistente',
                error_invalid_email_pass: 'E-mail o password non validi',
                error_password_no_match: 'Le password non coincidono',
                error_user_not_found: 'Nessun utente con questa e-mail',
                error_invalid_email: 'E-mail non valida',
                error_invalid_reset_token: 'Link non valido, richiedine un altro',
            },
            booking: {
                form: {
                    name: 'Nome e cognome',
                    email: 'Indirizzo e-mail',
                    phone: 'Numero di telefono',
                    number_of_people: 'Numero di persone',
                    number_of_people_max: 'Numero di persone (max {{max_people}})',
                    number_of_people_min: 'Numero di persone (min {{min_people}})',
                    number_of_people_max_min: 'Numero di persone (da {{min_people}} a {{max_people}})',
                    notes: 'Note / richieste speciali',
                    submit: 'Invia richiesta di prenotazione',
                    email_optional: '(facoltativo)',
                    date: 'Data',
                    duration: 'Durata',
                    seating: 'Orari disponibili',
                    number_of_guests: 'Numero di ospiti',
                    notes_placeholder: 'Allergie, occasione, preferenza di posto',
                    reserving: 'Prenotazione in corso...',
                    reserve_table: 'Prenota un tavolo',
                    please_choose_a_date_and_time: 'Scegli una data e un orario.',
                    invalid_people: 'Il numero di ospiti deve essere compreso tra {{min}} e {{max}}.',
                    party_size_max_fallback: 'il massimo consentito',
                    loading_available_times: 'Caricamento degli orari disponibili…',
                    select_a_date_to_see_available_times: 'Seleziona una data per vedere gli orari disponibili.',
                    no_times_available_for_this_date: 'Nessun orario disponibile per questa data. Scegli un altro giorno.',
                    shift: 'Turno',
                    service_times: 'Orari di servizio',
                    new_shift: 'Nuovo turno',
                    time: 'orario',
                    times: 'orari',
                    unavailable: 'Non disponibile',
                    available: 'Disponibile',
                    required_name: 'Inserisci il tuo nome.',
                    required_phone: 'Inserisci il tuo numero di telefono.',
                    required_email: 'Inserisci il tuo indirizzo e-mail.',
                    invalid_email: 'Inserisci un indirizzo e-mail valido.',
                    required_terms: 'Accetta i termini prima di prenotare.',
                    reservation_is_unavailable: 'La prenotazione non è disponibile.',
                    please_contact_the_restaurant_directly: 'Contatta direttamente il ristorante.',
                    almost_done: 'Quasi fatto',
                    your_details: 'I tuoi dati',
                    tell_us_who_s_coming: 'Dicci chi viene così possiamo confermare la tua prenotazione.',
                    book_your_table: 'Prenota il tuo tavolo',
                    choose_a_time_that_works_for_you: 'Scegli un orario che ti va bene.',
                    send_your_reservation_request_and_the_restaurant_will_take_care_of_the_rest: 'Invia la tua richiesta di prenotazione e il ristorante penserà al resto.',
                    select_date: 'Seleziona la data',
                    standard: 'Standard',
                    minutes: 'minuti',
                    next: 'Avanti →',
                    back: '← Indietro',
                    accept_terms: 'Accetto i termini e le condizioni.',
                    info_1: 'Riceverai un’e-mail quando la prenotazione sarà accettata o rifiutata',
                },
                errors: {
                    not_found: 'Prenotazione inesistente. Potrebbe essere stata eliminata',
                    generic: 'Qualcosa non ha funzionato, aggiorna la pagina o contattaci',
                    something_went_wrong: 'Qualcosa non ha funzionato',
                    accept_terms: 'Accetta i termini e le condizioni',
                    required_phone: 'Inserisci il numero di telefono',
                    required_email: 'Inserisci la tua e-mail',
                    required_zip: 'Inserisci il CAP di fatturazione',
                    required_name: 'Inserisci il nome',
                    invalid_email: 'Inserisci un indirizzo e-mail valido',
                    invalid_phone: 'Inserisci un numero di telefono valido',
                    invalid_people: 'Numero di persone non valido',
                    missing_custom_fields: 'Compila tutti i campi obbligatori.',
                    booking_capacity_threshold: 'Siamo al completo per questo orario. Prova un altro orario.',
                    slot_unavailable: 'Siamo al completo per questo numero di ospiti. Prova un altro orario.',
                    booking_date_paused: 'Le prenotazioni sono sospese per questa data. Scegli un altro giorno.',
                    invalid_table_assignment: 'Quei tavoli non possono ospitare il tuo gruppo. Scegli un altro orario.',
                    exceeded_order_limit: 'Troppe richieste di prenotazione. Riprova più tardi.',
                    validation_failed_recaptcha_v3: 'Rilevato traffico insolito. Stai usando una VPN? Completa la verifica qui sopra e riprova.',
                    validation_failed_recaptcha_v2: 'Non è stato possibile avviare la prenotazione. Riprova o usa un altro metodo. Se usi una VPN, prova prima a disattivarla.',
                    booking_already_exists: 'Questa prenotazione è già stata inviata. Controlla la tua e-mail o apri il link della prenotazione.',
                    invalid_party_size: 'Scegli un numero di ospiti valido.',
                    invalid_request: 'Richiesta non valida. Aggiorna la pagina e riprova.',
                    table_booking_unavailable: 'La prenotazione dei tavoli non è disponibile.',
                },
            },
            cart: {
                title: 'Carrello',
                proceed_to_checkout: 'Vai al pagamento',
                edit_dish: 'Modifica',
                remove_dish: 'Rimuovi',
                no_items_1: 'Nessun articolo nel carrello',
                no_items_2: 'Aggiungi articoli per continuare',
                free_delivery_notice: 'Consegna gratuita per ordini superiori a {{value, currency}}',
                errors: {
                    min_order_promo: 'È richiesto un valore minimo di {{value, currency}} nel carrello prima di applicare questa promozione',
                    min_order_delivery: 'È richiesto un valore minimo di {{value, currency}} nel carrello per la consegna',
                },
                promo: {
                    heading: 'Codice promozionale',
                    placeholder: 'Inserisci il codice promozionale',
                    add: 'Aggiungi codice',
                    title: 'Promozione {{name}} aggiunta al carrello',
                    fixed_discount: '{{value, currency}} di sconto',
                    percent_discount: '{{value}}% di sconto',
                    added_to_cart: 'Promozione aggiunta al carrello',
                    errors: {
                        not_found: 'Codice promozionale non trovato',
                        disabled: 'Promozione disattivata',
                        not_available: 'Promozione al momento non disponibile',
                        not_eligible: 'Non sei idoneo ad applicare questo codice promozionale',
                        not_available_time: 'La promozione non è valida per questo orario',
                        logged_in_only: 'Devi aver effettuato l’accesso per usare questa promozione',
                        already_used: 'Hai già usato questa promozione',
                        invalid: 'Questa promozione non è più valida',
                        invalid_service: 'Questa promozione non è valida per il servizio scelto',
                        later_only: 'Valida solo per ordini programmati (pre-order)',
                        now_only: 'Valida solo per ordini immediati, non per i pre-order',
                        generic: 'Oops… qualcosa non ha funzionato ed è stato registrato',
                        dishes_required_multi: 'Questa promozione si applicherà solo quando determinati articoli saranno nel carrello',
                        dishes_required_single: "Questa promozione si applica solo all’articolo '{{dish}}'",
                    },
                },
                tip: {
                    title: 'Mancia',
                    placeholder: 'Aggiungi una mancia',
                },
            },
            free_items_promo: {
                title: 'Articoli omaggio',
                usage_confirmation: {
                    question: 'Hai diritto a articoli gratuiti. Vuoi vederli e aggiungerli?',
                    cancellation: 'No, non voglio articoli gratuiti',
                    acceptance: 'Sì',
                },
                free_items_selection: {
                    multiple: {
                        description: 'Seleziona {{number}} articoli gratuiti',
                    },
                    single: {
                        description: 'Seleziona un articolo gratuito',
                    },
                    confirm_button: 'Conferma',
                },
            },
            checkout: {
                title: 'Pagamento',
                subtitle: 'Conferma i dettagli dell’ordine',
                details: {
                    service: 'Servizio',
                    due: 'Orario richiesto',
                    due_now_asap: 'Ora / ASAP',
                    address: 'Indirizzo di consegna',
                    total: 'Totale',
                    table: 'Tavolo',
                    store_location: 'Indirizzo del locale',
                },
                customer: {
                    title: 'Cliente',
                    subtitle: 'Accedi per salvare ordine e dati',
                    button: 'Accedi',
                    name: 'Nome e cognome',
                    email: 'E-mail',
                    phone: 'Telefono',
                    phone_important: 'Telefono (importante)',
                    notes: 'Note ordine',
                    delivery_notes: 'Istruzioni per la consegna / note ordine',
                    optional: 'opzionale',
                },
                payment: {
                    title: 'Metodo di pagamento',
                    qr_modal_help: 'Usa l’app mobile {{app}} per scansionare il QR code e completare il pagamento. Quando il pagamento è completato nell’app, puoi chiudere questa finestra. Non chiuderla finché il pagamento non è stato completato.',
                    switch_to_app_help: 'Toccando il pulsante sotto si aprirà automaticamente l’app mobile {{app}} per completare il pagamento. Quando il pagamento è completato nell’app, puoi chiudere questa finestra. Non chiuderla finché il pagamento non è stato completato.',
                    open_app: 'Apri applicazione {{app}}',
                    continue: 'Continua',
                    continue_to_payment: 'Continua con {{method}}',
                    back_to_cart: 'Torna al carrello',
                },
                accept_terms: 'Accetto termini e condizioni',
                accept_terms_view: 'Leggi',
                processing_order: 'Elaborazione ordine',
                warning: {
                    different_payment_currency: 'I prezzi del locale sono in {{store_currency}} ma il pagamento è in {{payment_currency}}',
                    closing_soon: 'In chiusura: gli ordini devono essere inviati entro {{value}} minuti',
                    closed: 'Questo servizio è chiuso e non accettiamo nuovi ordini',
                    paused: 'Questo servizio è stato sospeso e al momento non accettiamo ordini',
                    expired: 'Non possiamo più evadere l’ordine per l’orario selezionato. Scegli una data o un orario diverso.',
                },
                errors: {
                    walletly_promo: 'Errore promozione Walletly: provane un’altra',
                    stripe_generic: 'Errore sulla carta: riprova o scegli un altro metodo di pagamento',
                    validation_failed: 'Pagamento temporaneamente non disponibile. Riprova più tardi o scegli un altro metodo.',
                    validation_failed_recaptcha_v3: 'Traffico anomalo rilevato. Usi una VPN? Completa il controllo sopra e riprova.',
                    validation_failed_recaptcha_v2: 'Impossibile avviare il pagamento. Riprova o usa un altro metodo. Se usi una VPN, prova a disattivarla.',
                    stripe_loading_fail: 'Errore nel caricamento del modulo di pagamento, riprova',
                    something_went_wrong: 'Qualcosa non ha funzionato',
                    paypal_generic: 'Problema con PayPal, riprova o scegli un altro metodo di pagamento',
                    payment_fail: 'Pagamento non riuscito, riprova o scegli un altro metodo',
                    payment_cancelled: 'Pagamento annullato, riprova o scegli un altro metodo',
                    payment_error: 'Errore durante il pagamento online, riprova o scegli un altro metodo',
                    payment_declined: 'Metodo di pagamento rifiutato',
                    card_declined: 'Carta rifiutata e pagamento non completato',
                    promo_max_uses_exceeded: "Questo codice promo ha raggiunto il limite di utilizzo e non è più disponibile.",
                    store_closed: 'Il locale è chiuso e non accetta più ordini',
                    accept_terms: 'Accetta i termini e le condizioni',
                    required_payment: 'Seleziona un metodo di pagamento',
                    required_phone: 'Inserisci il numero di telefono',
                    required_email: 'Inserisci la e-mail',
                    required_zip: 'Inserisci il CAP di fatturazione',
                    required_name: 'Inserisci il nome',
                    invalid_email: 'Inserisci un indirizzo e-mail valido',
                    invalid_phone: 'Inserisci un numero di telefono valido',
                    invalid_cc_number: 'Il numero della carta non è valido',
                    invalid_order_amount: 'Importo minimo richiesto per questo metodo di pagamento',
                    retry_cc_number: 'Qualcosa non ha funzionato, inserisci di nuovo il numero di carta e riprova',
                    closed: 'Il locale è chiuso e non accetta ordini',
                    promo_login_required: 'Devi aver effettuato l’accesso per questa promozione',
                    promo_used: 'Hai già usato questa promozione',
                    promo_by_payment_method_not_applicable: 'Promozione non applicabile al metodo di pagamento selezionato.',
                    missing_custom_checkout_fields: 'Compila tutti i campi obbligatori.',
                    delivery_unavailable: 'La consegna potrebbe non essere disponibile in questo momento. Considera il ritiro in sede.',
                    required_delivery_provider: 'Scegli un corriere/consegna.',
                    required_delivery_quotation: 'Stima di consegna scaduta.',
                    exceeded_order_limit: 'Siamo in un picco di ordini al momento. Scegli un orario più tardi.',
                    exceeded_order_limit_later: 'Non possiamo più evadere l’ordine per l’orario selezionato. Scegli una data o un orario diverso.',
                },
                button: {
                    continue: 'Continua al pagamento',
                    place_order: 'Invia ordine',
                    update_order: 'Aggiorna ordine',
                },
                delivery_estimation: {
                    title: 'Stima di consegna',
                    details: {
                        provider: 'Corriere',
                        estimated_fee: 'Tariffa stimata',
                        estimated_total_fee: 'Totale spese di consegna',
                        estimated_discount_fee: 'Sconto sulle spese di consegna',
                        previous_estimated_fee: 'Tariffa stimata precedente',
                        tips: 'Mance',
                        estimated_delivery_time: 'Orario stimato di consegna',
                        uber_new_estimation: 'Richiedi nuova stima',
                        uber_new_estimation_success: 'Nuova stima Uber applicata.',
                        uber_estimation_expired: 'Stima di consegna scaduta',
                        uber_price: 'Abbiamo bloccato il prezzo Uber',
                        uber_need_time: 'Serve più tempo',
                        lalamove_price: 'Abbiamo bloccato la tariffa Lalamove',
                        lalamove_new_estimation_success: 'Nuova stima Lalamove applicata.',
                        lalamove_estimation_expired: 'Stima di consegna scaduta',
                        lalamove_need_time: 'Serve più tempo',
                        lalamove_new_estimation: 'Richiedi nuova stima',
                    },
                    quotation_error: 'Qualcosa non ha funzionato nel calcolo della stima di consegna.',
                },
            },
            customer: {
                age_v: {
                    title: 'Verifica dell’età',
                    required_for_items: 'Richiesta per alcuni articoli',
                    min_age: 'Età minima: {{age}} anni',
                    est_time: 'Tempo di verifica stimato: {{time}} ore',
                    upload_description: 'Carica un documento qui sotto per la verifica. Riceverai un’e-mail una volta verificato. Carica fino a 2 immagini da max 2 MB ciascuna',
                    pending_description_1: 'Grazie per l’invio dei documenti. Riceverai un’e-mail quando la verifica sarà approvata',
                    pending_description_2: 'Aggiorna la pagina per lo stato della verifica. Tempo stimato di verifica: {{time}} ore',
                    approved_description: 'Account verificato: puoi ordinare dai menu con restrizioni',
                    rejected_description: 'Documento respinto. Per riprovare, carica di nuovo un documento',
                    upload: 'Carica',
                    reupload: 'Ricarica documenti',
                    go_back: 'Indietro',
                    view_document: 'Visualizza documento {{number}}',
                    status: {
                        unverified: 'Non verificato',
                        pending: 'In attesa di approvazione',
                        approved: 'Verificato',
                        rejected: 'Rifiutato',
                    },
                },
                headings: {
                    sessions: 'Sessioni',
                    orders: 'Ordine',
                    spend: 'Spesa',
                    order_history: 'Storico ordini',
                    loyalty: 'Fedeltà',
                    loyalty_points: 'Punti fedeltà',
                    added: 'Promozione aggiunta.',
                },
                loyalty_errors: {
                    invalid_cart_items: 'Aggiungi almeno un articolo prima di riscattare.',
                    not_found: 'Promozione non trovata.',
                    already_exists: 'Promozione già applicata.',
                    try_again: 'Impossibile applicare l’offerta. Riprova.',
                },
            },
            custom_payment: {
                title: 'Pagamento {{name}}',
                description: 'Hai aperto il modulo di pagamento online. Completa i campi sotto per pagare. Se non inserisci un importo, i tuoi dati saranno salvati ma non sarà effettuato alcun addebito.',
                disabled: 'Questa pagina di pagamento non è configurata correttamente. Contatta il proprietario del sito.',
                success: 'Pagamento completato correttamente e dati salvati. Grazie',
                back: 'Torna alla home',
                fields: {
                    name: 'Nome e cognome',
                    email: 'Indirizzo e-mail',
                    reference: 'Rif. pagamento',
                    amount: 'Importo ($)',
                    name_on_card: 'Nome sulla carta',
                    submit: 'Paga ora',
                },
                warning: {
                    currency: 'Nota: importo del pagamento in {{actual}}, non {{default}}',
                },
                errors: {
                    generic: 'Qualcosa non ha funzionato, riprova o contattaci',
                    stripe_generic: 'Errore sulla carta: aggiorna la pagina e riprova',
                    payment_fail: 'Pagamento non riuscito, riprova o scegli un altro metodo',
                    payment_cancelled: 'Pagamento annullato, riprova o scegli un altro metodo',
                    payment_error: 'Errore durante il pagamento online, riprova o scegli un altro metodo',
                    payment_declined: 'Metodo di pagamento rifiutato',
                    card_declined: 'Carta rifiutata e pagamento non completato',
                    promo_max_uses_exceeded: "Questo codice promo ha raggiunto il limite di utilizzo e non è più disponibile.",
                },
            },
            dish: {
                add: 'Aggiungi al carrello',
                edit: 'Aggiorna articolo',
                notes: 'Indicazioni particolari...',
                ingredients: {
                    title: 'Ingredienti',
                    uncheck_remove: 'Deseleziona per rimuovere',
                },
                ingredients_title: 'Ingredienti',
                combo: {
                    choose_dish: 'Scegli un articolo',
                },
                option_sets: {
                    conditions: {
                        select_one: 'Seleziona una (obbligatorio)',
                        select_one_optional: 'Seleziona una (opzionale)',
                        select_between: 'Seleziona tra {{min}} e {{max}} (obbligatorio)',
                        select_at_least: 'Seleziona almeno {{qty}} (obbligatorio)',
                        select_up_to: 'Seleziona fino a {{qty}} (opzionale)',
                        select_multiple_optional: 'Seleziona più opzioni (opzionale)',
                        select_multiple: 'Seleziona più opzioni (obbligatorio)',
                        free_amount: 'Primi {{qty}} gratuiti / {{selected}} selezionati',
                    },
                    points: {
                        none_consumed: 'Puoi scegliere fino a {{maxFree}} opzioni gratuitamente',
                        less_than_total_points: 'Puoi scegliere altre opzioni gratuitamente',
                        greather_than_total_points: 'Puoi scegliere altre opzioni a pagamento supplementare',
                    },
                },
                error: 'Correggi le opzioni evidenziate in rosso',
                added_to_cart: 'Articolo aggiunto al carrello',
            },
            map: {
                zone_fee: 'Spese di consegna',
                view_in_google: 'Apri in Google Maps',
            },
            portal_go_back: {
                title: 'Tornare alla ricerca ristoranti?',
                description: 'Gli articoli nel carrello saranno eliminati',
                cancel: 'Annulla',
                proceed: 'Indietro',
            },
            order: {
                config: {
                    services: {
                        title: 'Scegli un servizio',
                        table_booking: 'Prenota tavolo',
                    },
                    address_custom: {
                        input_placeholder: 'Inserisci il tuo indirizzo',
                    },
                    address: {
                        input_placeholder: 'Trova il tuo indirizzo di consegna',
                        extras_placeholder: 'Scala, interno, citofono, istruzioni per il corriere, ecc.',
                        search_placeholder: 'Cerca il tuo indirizzo',
                        search_input_placeholder: 'Digita per cercare',
                        no_address_found: 'Nessun indirizzo trovato. Prova a digitare più di 5 caratteri',
                        not_found: 'Indirizzo di consegna non trovato o non valido, riprova',
                        not_delivering: 'Al momento non consegniamo a questo indirizzo',
                        not_in_range: 'L’indirizzo è fuori dal raggio del nostro locale',
                        not_in_zone: 'L’indirizzo non è in una zona di consegna attiva',
                        no_number: 'L’indirizzo deve includere il numero civico',
                        location_permission: 'Consentire a questo sito di accedere alla posizione attuale?',
                        location_permission_warning: 'Impossibile accedere alla posizione. Abilita i servizi di localizzazione sul dispositivo e nel browser. Alcuni riferimenti utili:',
                        pick_location: 'Scegli la posizione',
                        pick_location_help_text: 'Trascina il segnaposto sulla mappa per scegliere il punto.',
                        use_current_location: 'Usa posizione attuale',
                        locate_on_map: 'Individua sulla mappa',
                    },
                    datetime: {
                        title: 'Per quando vuoi l’ordine?',
                        due_now: 'Ora',
                        due_later: 'Più tardi',
                        service_not_available: 'Spiacenti, al momento non accettiamo ordini per {{service}}',
                        currently_closed: '{{service}} al momento chiuso, ma puoi ordinare per dopo',
                        due_unavailable: 'Non disponibile',
                        due_closed: 'Chiuso',
                        select_date: 'Seleziona data',
                        select_time: 'Seleziona orario',
                        select_order_date: 'Data dell’ordine',
                        select_order_time: 'Orario dell’ordine',
                        select_order_date_time: 'Data e orario dell’ordine',
                        select_booking_date: 'Data della prenotazione',
                        select_booking_time: 'Orario della prenotazione',
                        no_times_available: 'Nessun orario disponibile',
                        date_today: '(Oggi)',
                        date_closed: '(Chiuso)',
                        date_bookings_paused: '(Prenotazioni sospese)',
                        time_slot_closed: 'Chiuso',
                    },
                    number_of_people: {
                        placeholder: 'Numero di persone',
                    },
                    table: {
                        select: 'Seleziona tavolo',
                        select_popup_title: 'Scegli il tavolo',
                        password: 'Password tavolo',
                        password_warning: 'Inserisci la password del tavolo per continuare',
                    },
                    warning: {
                        closed: 'Spiacenti, siamo chiusi o non accettiamo ordini in questo momento',
                        not_available: 'Spiacenti, al momento non accettiamo ordini',
                    },
                    eta: {
                        delivery: `Tempo di consegna stimato: circa {{minutesToCustomer}} minuti`,
                        pickup: `L’ordine sarà pronto in circa {{minutesToCustomer}} minuti`,
                    },
                    start_button: 'Inizia ordine',
                },
                history: {
                    invalid: 'Riordine non disponibile: alcuni articoli sono stati modificati o non sono più disponibili',
                },
                reorder: {
                    title: 'Riordina in fretta',
                    description: 'Riordina facilmente articoli dai tuoi ordini precedenti',
                },
            },
            receipt: {
                errors: {
                    not_found: 'Ordine non trovato, aggiorna la pagina e riprova',
                    booking_not_found: 'La prenotazione non esiste. Potrebbe essere stata eliminata',
                    generic: 'Qualcosa non ha funzionato, aggiorna la pagina o contattaci',
                },
                connection: {
                    connected: 'Aggiornamenti in tempo reale',
                    connecting: 'Connessione agli aggiornamenti in tempo reale…',
                    disconnected: 'Aggiornamenti in tempo reale disconnessi',
                },
            },
            warnings: {
                logout: {
                    pretitle: 'Attenzione',
                    title: 'Esci',
                    body: 'Uscendo verranno rimossi gli articoli nel carrello',
                    cancel: 'Annulla',
                    proceed: 'Continua',
                },
                order_restart: {
                    warning: 'Attenzione',
                    title: 'Modifica dettagli ordine',
                    body: 'Modificando i dettagli potresti perdere gli articoli nel carrello se non più disponibili',
                    cancel: 'Annulla',
                    proceed: 'Continua',
                },
                order_expired: {
                    subtitle: 'Importante',
                    title: 'Ordine impostato come immediato',
                    description: 'L’orario scelto è molto ravvicinato; l’ordine è stato quindi modificato come da evadere subito / ASAP',
                    button: 'Ok',
                },
                order_expiring: {
                    subtitle: 'Importante',
                    title: 'Scadenza ordine vicina',
                    description: 'L’ordine va inviato entro {{time, timeFromTimestamp}}, altrimenti non sarà più valido',
                    button: 'Ok',
                },
                location_permission: {
                    cancel: 'Annulla',
                    proceed: 'Continua',
                },
            },
            card_payment_authentication: {
                title: 'Autenticazione del pagamento',
                note: 'Non chiudere questa finestra finché non hai completato l’autenticazione richiesta dalla tua banca.',
            },
            maps: {
                cancel: 'Annulla',
                use_location: 'Usa posizione',
            },
            app_refresh: {
                refresh: 'Aggiorna',
                title: 'Aggiorna locale',
                description: 'Il locale è stato aggiornato. Aggiorna il browser per la versione più recente; potrebbe essere necessario riaprire il carrello per continuare il pagamento.',
            },
        },
        sections: {
            nav_top: {
                guest: 'Ospite',
                login: 'Accedi',
                login_signup: 'Accedi / Registrati',
                logout: 'Esci',
            },
            menus: {
                info: {
                    no_menus: 'Non ci sono menu disponibili',
                    restrictions: 'Restrizioni menu',
                    not_available: 'Menu non disponibile',
                    unavailable: {
                        times: 'Menu non disponibile: i requisiti dell’ordine non corrispondono',
                        services: 'Menu non disponibile: i requisiti dell’ordine non corrispondono',
                        hours: 'Menu non disponibile: l’orario richiesto è fuori dall’orario del menu',
                        pre_order: 'Menu non disponibile: l’ordine non soddisfa i requisiti di pre-order',
                        age: 'Menu non disponibile: è richiesto un account con verifica dell’età',
                    },
                    services: {
                        title: 'Requisiti ordine',
                        pickup: 'Asporto',
                        delivery: 'Consegne',
                        dine_in: 'Al tavolo',
                    },
                    times: {
                        now: 'Nessun pre-ordine',
                        later: 'Solo pre-ordini',
                    },
                    hours: {
                        title: 'Orari disponibili',
                    },
                    preorder: {
                        title: 'Requisiti pre-ordine',
                        days_in_advance: 'Ordina con {{days}} giorni di anticipo',
                        cutoff_time: 'Chiusura ultimo giorno alle {{time, timeFromTime}}',
                    },
                    age_restricted: {
                        title: 'Limite di età',
                        approved: 'Account verificato, puoi ordinare da questo menu',
                        rejected: 'Verifica dell’età richiesta: crea un account e carica un documento',
                    },
                },
                search: {
                    title: 'Cerca nel menu',
                    no_result: 'Nessun risultato. Prova con altre parole.',
                    placeholder: 'Cosa cerchi?',
                },
            },
            category: {
                restrictions: 'Restrizioni categoria',
                not_available: 'Categoria non disponibile',
                unavailable: {
                    services: 'Categoria non disponibile: i requisiti dell’ordine non corrispondono',
                    hours: 'Categoria non disponibile: l’orario non è negli orari disponibili',
                },
            },
            info: {
                location: {
                    title: 'Posizione',
                    view_map: 'Apri mappa',
                    phone: 'Telefono',
                },
                hours: {
                    title: 'Orari di apertura',
                    title_special: 'Orari speciali',
                },
                services: {
                    title: 'Servizi',
                    notes: 'Note',
                    delivery: {
                        ranges: 'Aree di consegna',
                        zones: 'Zone di consegna',
                        view_zones: 'Vedi zone sulla mappa',
                        fee: 'Spese di consegna',
                        fee_short: 'Tariffa',
                        fee_varies: 'Variabile, indicato nel carrello',
                        min_order: 'Ordine minimo',
                        min_order_short: 'Ord. min.',
                        no_min_order: 'Nessun ordine minimo',
                        free_amount: 'Soglia consegna gratuita',
                    },
                },
            },
            contact: {
                title: 'Contattaci',
                name: 'Nome',
                email: 'E-mail',
                phone: 'Telefono',
                message: 'Scrivi il tuo messaggio…',
                send: 'Invia messaggio',
                success: 'Messaggio inviato correttamente',
                error: 'Qualcosa non ha funzionato, riprova più tardi',
            },
            footer: {
                powered_by: 'Offerto da',
                terms_and_conditions: 'Termini e condizioni',
                privacy: 'Informativa sulla privacy',
                cookie: 'Cookie policy',
            },
        },
        pages: {
            payment_completed: {
                title: 'Pagamento ricevuto. Grazie per l’ordine!',
                subtitle: 'I dettagli sono stati inviati al tuo indirizzo e-mail.',
                back_to_menu: 'Torna al menu',
                close_tab: 'Chiudi scheda',
            },
            payment_failed: {
                title: 'Si è verificato un errore durante il pagamento.',
                subtitle: '',
                back_to_menu: 'Torna al menu',
                close_tab: 'Chiudi scheda',
            },
        },
    },
    // MODELS
    booking: {
        receipt: {
            title: 'Ricevuta prenotazione',
            details: {
                datetime: 'Prenotazione per',
                number_of_people: 'N. persone',
                placed: 'Creata',
                updated: 'Ultimo aggiornamento',
                notes: 'Note',
                name: 'Nome',
                email: 'E-mail',
                phone: 'Telefono',
                store_address: 'Indirizzo locale',
            },
            status_update: {
                title: 'Prenotazione {{number}} aggiornata',
                body: 'Lo stato della prenotazione è: {{status}}',
            },
            email_common: {
                name: 'Nome: {{name}}',
                phone: 'Telefono: {{number}}',
                number_of_people: 'N. persone: {{number}}',
                date: 'Data: {{date}}',
                time: 'Ora: {{time}}',
                location: 'Locale: {{name}}',
                notes: 'Note: {{name}}',
            },
            email_new_booking_restaurant: {
                subject: 'Nuova prenotazione tavolo {{number}} — {{name}}',
                powered_by: 'Offerto da {{name}}',
                overview: 'Nuova richiesta di prenotazione',
                title: 'Nuova prenotazione per {{name}}',
                subtitle: 'N. prenotazione {{number}}',
                description_confirmed: 'La prenotazione è stata confermata automaticamente. Puoi annullarla dalla dashboard di amministrazione; il cliente sarà avvisato via e-mail.',
                description_unconfirmed: 'Conferma o rifiuta la prenotazione dalla dashboard di amministrazione.',
                url_pre_text: 'Visualizza e aggiorna su',
            },
            email_new_booking_customer: {
                subject: 'Richiesta di prenotazione tavolo',
                powered_by: 'Offerto da {{name}}',
                overview: 'Nuova richiesta di prenotazione',
                title: 'Grazie per la prenotazione',
                subtitle: 'N. prenotazione {{number}}',
                description: '<b>Riceverai un’altra e-mail quando la prenotazione sarà confermata o rifiutata.</b><br>Contattaci per modifiche. Dettagli:',
                url_pre_text: 'Ricevuta prenotazione in tempo reale:',
            },
            email_update_booking_customer: {
                subject_confirmed: 'Prenotazione tavolo confermata',
                subject_unconfirmed: 'Prenotazione tavolo annullata',
                powered_by: 'Offerto da {{name}}',
                overview: 'Aggiornamento prenotazione',
                title_confirmed: 'Prenotazione confermata',
                title_unconfirmed: 'Prenotazione annullata',
                subtitle: 'N. prenotazione {{number}}',
                description_confirmed: 'Non vediamo l’ora di accoglierti. Contattaci per modifiche.',
                description_unconfirmed: 'Non possiamo accettare questa richiesta di prenotazione. Ci scusiamo per il disagio. Per domande, contattaci.',
                url_pre_text: 'Ricevuta prenotazione in tempo reale:',
            },
            email_status_update_customer: {
                subject: 'Prenotazione #{{number}} – {{subjectLabel}}',
                body: 'La tua prenotazione #{{number}} da {{store}} è ora {{status}}.',
            },
            errors: {},
            status_warning: 'Aggiorna lo stato di questa prenotazione nella dashboard, sezione prenotazioni.',
        },
    },
    email_delayed_order: {
        subject: 'Ordine #{{number}} – {{subjectLabel}}',
        header: 'Orario di preparazione aggiornato',
        title: 'Orario di preparazione aggiornato',
        order_number: 'Numero d\'ordine: {{number}}',
        description: 'Il tuo ordine sarà pronto alle {{time}}.',
        order_time_updated_to: 'L\'orario del tuo ordine è stato aggiornato.',
        powered_by: 'Offerto da {{name}}',
        button_text: "Traccia l'ordine",
        subject_label: 'Orario di preparazione aggiornato',
        subject_label_delivery: 'Orario di consegna aggiornato',
        body_ready: 'Il tuo ordine sarà pronto alle {{time}}.',
        body_delivery: 'Il tuo ordine sarà consegnato alle {{time}}.',
    },
    order: {
        receipt: {
            est_ready_time: 'Orario stimato disponibilità',
            est_driver_pickup_time: 'Stima ritiro corriere',
            est_delivery_time: 'Stima consegna',
            tab_details: 'Dettagli',
            tab_dishes: 'Articoli',
            future_order: 'Ordine programmato',
            reprint: 'RISTAMPA',
            details: {
                order_no: 'N. ordine',
                status: 'Stato',
                placed: 'Ricevuto',
                due: 'Orario previsto',
                due_asap: 'Ora / ASAP',
                last_updated: 'Ultimo aggiornamento',
                total: 'Totale',
                type: 'Tipo',
                origin: 'Origine',
                table: 'Tavolo',
                number_of_people: 'N. persone',
                payment_method: 'Pagamento',
                payment_status: 'Stato pagamento',
                payment_currency: 'Valuta pagamento',
                notes: 'Note',
                name: 'Nome',
                email: 'E-mail',
                phone: 'Telefono',
                distance: 'Distanza',
                driving_time: 'Tempo di percorrenza',
                delivery_zone: 'Zona',
                delivery_address: 'Indirizzo di consegna',
                delivery_provider: 'Corriere',
                delivery_tracking: 'Tracciamento',
                delivery_return_tracking: 'Traccia ritorno',
                delivery_tracking_link: 'Link tracciamento',
                tookan_status: 'Stato Tookan',
                tookan_status_failed_book: 'Prenotazione consegna fallita',
                tookan_status_failed_update: 'Aggiornamento prenotazione fallito',
                tookan_status_success: 'Confermato per la consegna',
                store_address: 'Indirizzo locale',
                destination: 'Destinazione',
                estimated_arrival_time: 'Arrivo stimato',
                delivery_status: 'Stato',
                delivery_track_your_order: 'Traccia ordine',
                delivery_text: 'Consegna',
                arrival_date: 'Data arrivo',
            },
            dishes: {
                headings: {
                    quantity: 'Qtà',
                    item: 'Articolo',
                    price: 'Prezzo',
                },
                notes: 'Note',
                remove_ingredients: 'Rimuovi ingredienti',
            },
            status_update: {
                title: 'Ordine {{number}} aggiornato',
                body: 'Lo stato del tuo ordine è: {{status}}',
            },
            wait_time_update: {
                title: 'Ordine {{number}} aggiornato',
                body: "L’orario previsto per l’ordine è stato aggiornato",
            },
            delivery_update: {
                title: 'Ordine {{number}} aggiornato',
                body: 'Il tuo ordine è stato confermato per la consegna. Vedi il link di tracciamento in tempo reale.',
            },
            payment_status_update: {
                title: 'Ordine {{number}} aggiornato',
                body: 'Lo stato di pagamento del tuo ordine è stato aggiornato.',
            },
            email_new_order_restaurant: {
                subject: 'Nuovo ordine ({{number}}) — {{name}}',
                powered_by: 'Offerto da {{name}}',
                overview: 'Notifica nuovo ordine',
                title: 'Nuovo ordine presso {{name}}',
                subtitle: 'N. ordine {{number}}',
                description: 'Dettagli e aggiornamenti nella dashboard di amministrazione.',
                button_text: 'Traccia ordine',
                track_delivery_button_text: 'Traccia consegna',
            },
            email_new_order_customer: {
                subject: 'Ricevuta ordine ({{number}})',
                powered_by: 'Offerto da {{name}}',
                overview: 'Notifica ordine',
                title: 'Nuovo ordine presso {{name}}',
                subtitle: 'N. ordine {{number}}',
                description: 'Visualizza dettagli e aggiornamenti sulla ricevuta online in tempo reale.',
                button_text: 'Traccia ordine',
                track_delivery_button_text: 'Traccia consegna',
            },
            email_order_completed_by_customer: {
                subject: 'Ordine ({{number}}) completato dal cliente',
                powered_by: 'Offerto da {{name}}',
                overview: 'Notifica ordine completato',
                title: 'Ordine completato presso {{name}}',
                subtitle: 'N. ordine {{number}}',
                description: 'Consulta dettagli e stato dalla dashboard o dalla ricevuta:',
            },
        },
        totals: {
            tax: '{{name}} ({{percent}}%)',
            tax_in_prices: '{{name}} ({{percent}}%) incl. nel prezzo',
            fee: '{{name}} ({{value, currency}} + {{percent}}%)',
            fee_percent: '{{name}} ({{percent}}%)',
            fee_fixed: '{{name}}',
            delivery_fee: 'Spese di consegna',
            delivery_fee_offset: 'Sconto spese di consegna',
            delivery_fee_total: 'Totale spese di consegna',
            promo: 'Sconto: {{name}} ({{value, currency}} + {{percent}}% di sconto)',
            promo_percent: 'Sconto: {{name}} ({{percent}}%)',
            promo_fixed: 'Sconto: {{name}}',
            promo_none: 'Sconto: {{name}}',
            cart: 'Carrello',
            tip: 'Mancia',
            total: 'Totale',
        },
        status: {
            unconfirmed: 'Non confermato',
            awaiting_payment: 'In attesa del pagamento',
            confirmed: 'Confermato',
            ready: 'Pronto',
            on_route: 'In consegna',
            complete: 'Completato',
            cancelled: 'Annullato',
            seated: 'Accomodato',
        },
        searching: {
            lalamove_search_placeholder: 'Cerca ordine per ID consegna Lalamove',
        },
    },
    restaurant: {
        menus: {
            option_set: {
                option: {
                    unavailable: 'Non disponibile',
                },
            },
            dish: {
                no_stock: 'Esaurito',
                not_available: 'Non disponibile',
            },
        },
    },
    admin: {
        registration: {
            register_confirmation_code_subject: 'Codice di conferma e-mail',
            register_confirmation_code_email: 'Il tuo codice di conferma è {{confirmation_code}} (scade tra 24 ore)',
            register_confirmation_code_email_onbehalf: 'Il tuo codice di conferma è {{confirmation_code}} (scade tra 24 ore), per l’indirizzo e-mail {{email}}.',
        },
    },
};
//# sourceMappingURL=it.js.map